import { render, staticRenderFns } from "./NewPatentForm.vue?vue&type=template&id=56acc0f8"
import script from "./NewPatentForm.vue?vue&type=script&lang=js"
export * from "./NewPatentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports